/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ command: NonNullable<unknown> }} Drastic_Tech_Embed_Command_LogInputs */

const en_drastic_tech_embed_command_log = /** @type {(inputs: Drastic_Tech_Embed_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[CREATOR] Command: ${i?.command}`)
};

const fr_drastic_tech_embed_command_log = /** @type {(inputs: Drastic_Tech_Embed_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[CREATOR] Commande : ${i?.command}`)
};

const de_drastic_tech_embed_command_log = /** @type {(inputs: Drastic_Tech_Embed_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[ERSTELLER] Befehl: ${i?.command}`)
};

const it_drastic_tech_embed_command_log = /** @type {(inputs: Drastic_Tech_Embed_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[CREATORE] Comando: ${i?.command}`)
};

const ru_drastic_tech_embed_command_log = /** @type {(inputs: Drastic_Tech_Embed_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[СОЗДАТЕЛЬ] Команда: ${i?.command}`)
};

const es_drastic_tech_embed_command_log = /** @type {(inputs: Drastic_Tech_Embed_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[CREADOR] Comando: ${i?.command}`)
};

const zh_cn2_drastic_tech_embed_command_log = /** @type {(inputs: Drastic_Tech_Embed_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[创建者] 命令：${i?.command}`)
};

const ja_drastic_tech_embed_command_log = /** @type {(inputs: Drastic_Tech_Embed_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[CREATOR] コマンド: ${i?.command}`)
};

const hi_drastic_tech_embed_command_log = /** @type {(inputs: Drastic_Tech_Embed_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[निर्माता] कमांड: ${i?.command}`)
};

const pt_pt2_drastic_tech_embed_command_log = /** @type {(inputs: Drastic_Tech_Embed_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[CRIADOR] Comando: ${i?.command}`)
};

/**
* | output |
* | --- |
* | "[CREATOR] Command: {command}" |
*
* @param {Drastic_Tech_Embed_Command_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_embed_command_log = /** @type {((inputs: Drastic_Tech_Embed_Command_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Embed_Command_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_embed_command_log(inputs)
	if (locale === "de") return de_drastic_tech_embed_command_log(inputs)
	if (locale === "it") return it_drastic_tech_embed_command_log(inputs)
	if (locale === "ru") return ru_drastic_tech_embed_command_log(inputs)
	if (locale === "es") return es_drastic_tech_embed_command_log(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_embed_command_log(inputs)
	if (locale === "ja") return ja_drastic_tech_embed_command_log(inputs)
	if (locale === "hi") return hi_drastic_tech_embed_command_log(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_embed_command_log(inputs)
	return en_drastic_tech_embed_command_log(inputs)
});